import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import Color from '../../../utils/colors';
import { Font, FontWeight } from '../../../utils/fonts';
import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

class FilterBlock extends Component {
    render() {
        const {
            className, children = '', handleSwitchFilter, isActive,
        } = this.props;

        return (
            <Root className={className} onClick={handleSwitchFilter} isActive={isActive}>
                {children}
            </Root>
        );
    }
}

const Root = styled.div`
    display: inline-flex;
    align-items: center;

    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    font-size: 14px;
    line-height: 18px;

    white-space: nowrap;

    color: rgba(0, 0, 0, .3);

    ${({ isActive }) => isActive && css`
        color: ${Color.SECONDARY};
        background: rgba(194, 206, 232, .4);

        padding: 4px 7px;
    `}

    cursor: pointer;

    ${mediaWidth.m} {
        padding: 7px 12px;

        font-size: 16px;
        line-height: 21px;
    }

    ${mediaWidth.xl} {
        font-size: 16px;
        line-height: 21px;

        padding: 5px 10px;
    }
`;

export default FilterBlock;
